require('./RAGuideLink.scss');

// @vendors
const React = require('react');

// @commons
const { OKLink } = require('commonsComponents/OKLink');
const { recordLinkCommonV2 } = require('commonsUtilities/tagging');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

// @utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const { PRODUCTION_RA_ENVIRONMENT } = require('../../raConstants/index');

class RAGuideLink extends React.Component {
    render() {
        const isProduction = __ENVIRONMENT__ !== PRODUCTION_RA_ENVIRONMENT;

        const link = (
            <OKLink
                to={formatText('raGuideLink-linkUrl')}
                modifier="emphasize"
                target="_blank"
                onClick={() => {
                    recordLinkCommonV2(
                        {
                            categoriaEvento: 'interaccion en invertimos por ti',
                            accionEvento: 'como funciona roboadvisor',
                        },
                        isProduction,
                    );
                }}
            >
                <FormattedText value="raGuideLink-linkText" />
            </OKLink>
        );
        const content = (
            <FormattedTextWithComponents
                value="raGuideLink-content"
                injectedComponents={[link]}
            />
        );
        return <div className="ra-guide-link__container">{content}</div>;
    }
}

module.exports = RAGuideLink;
